<template>
	<div class="brick">
		<div class="list_top_box">
			<div class="left_option">
				<em class="lt_text">Sales Date</em>
				<span class="mgr_5"> <CustomDatePicker v-model="so_date_from"/> ~ <CustomDatePicker v-model="so_date_to"/></span>
				<a href="javascript:;" class="search_bt" @click="search()">Search</a>
				<a href="javascript:;" class="gray_bt mgr_15" @click="reset()">Reset</a>
			</div>
		</div>

		<table class="list_tbl" v-columns-resizable>
			<thead>
				<tr>
					<th width="6%">Ship To</th>
					<th width="15%">Ship To Name</th>
					<th width="10%">Status</th>
					<th width="7%">S/O No</th>
					<th width="7%">S/O Date</th>
					<th width="7%">Inv. No</th>
					<th width="7%">Inv. Date</th>
					<th width="8%">Country</th>
					<th width="12%">Sales Group</th>
					<!-- <th width="5%">S/O Amt.</th> -->
					<!-- <th width="4%">Inv. Amt.</th> -->
					<th>Accounting</th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="(invoice, index) in invoices" v-bind:key="invoice.invoice_no">
					<td class="al_left">
						<template v-if="index == 0 || (index > 0 && invoice.ship_to_code != invoices[index - 1].ship_to_code)">
							{{ invoice.ship_to_code }}
						</template>
					</td>
					<td class="al_left truncate">
						<template v-if="index == 0 || (index > 0 && invoice.ship_to_code != invoices[index - 1].ship_to_code)">
							{{ invoice.ship_to_name }}
						</template>
					</td>
					<td class="al_center">{{ invoice.status_code | saleStatusName }}</td>
					<td class="al_left">
						<a href="javascript:;" @click="selectSo(invoice)"
							><font :color="invoice.urgent_yn == 'Y' ? 'red' : 'black'">{{ invoice.so_dn }}</font></a
						>
					</td>
					<td class="al_center">{{ invoice.so_date }}</td>
					<td class="al_left">
						<a href="javascript:;" @click="selectInvoice(invoice)"
							><font :color="invoice.urgent_yn == 'Y' ? 'red' : 'black'">{{ invoice.invoice_dn }}</font></a
						>
					</td>
					<td class="al_center">{{ invoice.invoice_date }}</td>

					<td class="al_left">{{ invoice.ship_to_country }}</td>
					<td class="al_left">{{ invoice.sales_group_name }}</td>
					<!-- <td class="al_right">{{ invoice.total_amount | toCurrency }}</td> -->
					<!-- <td class="al_right">{{ invoice.total_shipped_amount | toCurrency }}</td> -->
					<td class="al_left">{{ invoice.remark }}</td>
				</tr>
			</tbody>
		</table>
		<div style="text-align:right;padding-right:10px;">Total Count : {{ list_count | commaSeparated }}</div>

		<Paging ref="paging" v-on:gotoPage="gotoPage"></Paging>

		<!-- <div class="bottom_bt_box">
			<ul>
				<li><a href="javascript: void(0);" class="gray_bt" @click="salesOrderPrint">Print</a></li>
				<li v-if="modifiable && (invoice_type == 'S' || (invoice_type == 'R' && user.so_return))">
					<router-link class="gray_bt" :to="{ name: 'soDetail', params: { mode: 'add' }, query: { backUri: this.uri, initial_invoice_type: this.invoice_type } }">Add</router-link>
				</li>
			</ul>
		</div> -->
	</div>
</template>

<script>
import { apiSelectDelayedInvoiceList } from '@/api/sales/invoice.js';
import Paging from '@/components/common/Paging';
import CustomDatePicker from '@/components/common/CustomDatePicker.vue';
import { today, daysAgo } from '@/utils/date.js';

export default {
	data: function() {
		return {
			uri: null,
			backUri: '/',
			paging_yn: 'Y',
			page_size: 25,
			page_no: 1,
			list_count: 0,

			// invoice_type: 'S',
			// status_code: null,
			so_date_from: daysAgo(30),
			so_date_to: today(),
			// sales_group_code: null,
			// ship_to_code: null,
			// bill_to_code: null,
			// state: null,
			// keyword: null,
			// channel: null,
			// return_type_code: null,
			// auto_approved: false,

			// sort_key: 'so_date',
			// sort_direction: 'DESC',

			// salesGroups: [],
			// states: [],
			// saleStatusCodes: [],
			// returnTypes: [],

			invoices: [],
		};
	},
	computed: {
		modifiable() {
			var menus = this.$session.get('menus');
			for (var i = 0; i < menus.length; i++) {
				// if (menus[i].path == this.$router.history.current.path && menus[i].modify_yn == 'Y') return true;
				if ((menus[i].path == this.$router.history.current.path || menus[i].path == this.$router.history.current.path.replace('add', 'detail')) && menus[i].modify_yn == 'Y') return true;
			}
			return false;
		},
		user: function() {
			return this.$session.get('user');
		},
	},
	components: {
		CustomDatePicker,
		Paging,
	},
	methods: {
		selectInvoice(invoice) {
			this.$router.push({ name: 'invoiceDetail', params: { mode: 'detail' }, query: { backUri: this.uri, invoice_no: invoice.invoice_no } });
		},
		selectSo(invoice) {
			this.$router.push({ name: 'soDetail', params: { mode: 'detail' }, query: { backUri: this.uri, invoice_no: invoice.invoice_no } });
		},
		gotoPage(pageNo) {
			this.page_no = pageNo;
			this.selectDelayedInvoices(pageNo);
		},
		reset() {
			//this.status_code = null;
			this.so_date_from = daysAgo(30);
			this.so_date_to = today();
			// this.sales_group_code = null;
			// this.ship_to_code = null;
			// this.bill_to_code = null;
			// this.state = null;
			// this.keyword = null;
			// this.auto_approved = false;
		},
		async search() {
			await this.selectDelayedInvoices();
		},
		async selectDelayedInvoices(pageNo) {
			if (pageNo) this.page_no = pageNo;
			else this.page_no = 1;

			var param = {
				paging_yn: this.paging_yn,
				page_size: this.page_size,
				page_no: this.page_no,
				start_index: this.page_size * (this.page_no - 1),
				// sort_key: this.sort_key,
				// sort_direction: this.sort_direction,

				// invoice_type: this.invoice_type,
				// status_code: this.status_code,
				so_date_from: this.so_date_from,
				so_date_to: this.so_date_to,
				// sales_group_code: this.sales_group_code,
				// ship_to_code: this.ship_to_code,
				// bill_to_code: this.bill_to_code,
				// state: this.state,
				// keyword: this.keyword,
				// channel: this.channel,
				// normal_temp_type: 'all',

				// include_retail_count: true,
				// retail_order_status: 'O',
				// retail_order_date_from: daysAgo(6),
				// retail_order_date_to: today(),
			};
			const { data } = await apiSelectDelayedInvoiceList(param);

			this.invoices = data.delayedInvoiceList;
			this.list_count = data.list_count; //data.list_count;

			this.$refs.paging.setPage(this.page_no, this.page_size, this.list_count);

			var uri = '/sales/delayed_invoice?page_no=' + this.page_no;
			// if (this.invoice_type) uri += '&invoice_type=' + this.invoice_type;
			// if (this.keyword) uri += '&keyword=' + this.keyword;
			// if (this.status_code) uri += '&status_code=' + this.status_code;
			// if (this.return_type_code) uri += '&return_type_code=' + this.return_type_code;
			if (this.so_date_from) uri += '&so_date_from=' + this.so_date_from;
			if (this.so_date_to) uri += '&so_date_to=' + this.so_date_to;
			// if (this.sales_group_code) uri += '&sales_group_code=' + this.sales_group_code;
			// if (this.ship_to_code) uri += '&ship_to_code=' + this.ship_to_code;
			// if (this.bill_to_code) uri += '&bill_to_code=' + this.bill_to_code;
			// if (this.state) uri += '&state=' + this.state;
			// if (this.channel) uri += '&channel=' + this.channel;
			// if (this.auto_approved) uri += '&auto_approved=' + this.auto_approved;

			this.uri = uri;
			window.history.pushState({}, null, uri);
		},
		async index() {
			// const { data } = await apiSoIndex();
			// this.salesGroups = data.salesGroupList;
			// this.returnTypes = data.returnTypeList;
			// this.states = data.stateList;
		},
		async init() {
			//await this.index();
			//this.saleStatusCodes = this.$saleStatusCodes;

			// if (this.$route.query.invoice_type) this.invoice_type = this.$route.query.invoice_type;
			// if (this.$route.query.keyword) this.keyword = this.$route.query.keyword;
			// if (this.$route.query.status_code) this.status_code = this.$route.query.status_code;
			// if (this.$route.query.return_type_code) this.return_type_code = this.$route.query.return_type_code;
			if (this.$route.query.so_date_from) this.so_date_from = this.$route.query.so_date_from;
			if (this.$route.query.so_date_to) this.so_date_to = this.$route.query.so_date_to;
			// if (this.$route.query.sales_group_code) this.sales_group_code = this.$route.query.sales_group_code;
			// if (this.$route.query.ship_to_code) this.ship_to_code = this.$route.query.ship_to_code;
			// if (this.$route.query.bill_to_code) this.bill_to_code = this.$route.query.bill_to_code;
			// if (this.$route.query.state) this.state = this.$route.query.state;
			// if (this.$route.query.channel) this.channel = this.$route.query.channel;
			// if (this.$route.query.auto_approved) this.auto_approved = this.$route.query.auto_approved;
			// if (this.$route.query.initial_invoice_type) this.invoice_type = this.$route.query.initial_invoice_type;

			await this.selectDelayedInvoices(this.$route.query.page_no);
		},
	},
	created() {
		this.$store.commit('setSideIndex', 3);
		this.$store.commit('setSelectedMenu', 'nav_li_delayed_invoice');
		this.$store.commit('setSubTitle', 'Sales -> Delayed Sales Order / Invoice');

		this.init();
	},
};
</script>

<style></style>
